import { render } from "./CarStatuses.vue?vue&type=template&id=5237cdac&scoped=true&ts=true"
import script from "./CarStatuses.vue?vue&type=script&lang=ts"
export * from "./CarStatuses.vue?vue&type=script&lang=ts"

import "./CarStatuses.vue?vue&type=style&index=0&id=5237cdac&lang=scss&scoped=true"

import exportComponent from "/var/www/logiplanner_web_prod/logiplanner_web/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5237cdac"]])

export default __exports__